import React, {Component} from 'react';
import './ScrolledHeader.css';

class ScrolledHeader extends Component {
	render() {
		return <h1 className="ScrolledHeader">{this.props.children}</h1>;
	}
}

export default ScrolledHeader;



// WEBPACK FOOTER //
// ./src/widgets/ScrolledHeader.js